<script setup>
const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: '<LABEL>',
  },
  trueValue: {
    type: [Boolean, String],
    default: true,
  },
  falseValue: {
    type: [Boolean, String],
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: null,
  },
})

const modelValue = defineModel({
  type: [Boolean, String],
  default: false,
})
</script>

<template>
  <div>
    <input
      :id="id"
      v-model="modelValue"
      type="checkbox"
      class="checkbox__input"
      :true-value="props.trueValue"
      :false-value="props.falseValue"
      :required="required"
    >
    <label
      :for="id"
      class="equal-base equal-base--tighter"
    >
      <IconsCheck
        v-if="modelValue === props.trueValue"
        class="checkbox__icon"
      />
      <slot>
        {{ props.label }}
      </slot>
    </label>

    <div
      v-if="props.error"
      class="equal-small-3 checkbox__error"
    >
      {{ props.error }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';

.checkbox {
  &__input {
    position: absolute;
    opacity: 0;

    & + label {
      display: inline-block;
      position: relative;
      cursor: pointer;
      padding-left: 22px + 9px;

      // checkbox
      &:before {
        position: absolute;
        display: block;
        left: 0;
        top: 0;
        content: '';
        background: transparent;
        width: 22px;
        height: 22px;

        border: 1px solid $color-light;
        border-radius: 4px;

        transition: 200ms ease-in-out all;
      }
    }
  }

  &__icon {
    height: 11px;
    width: 14px;
    position: absolute;
    left: 4px;
    top: 6px;
    fill: $color-light;
  }
}
.checkbox__error {
  margin-top: 10px;
  color: #ee2323;
}
</style>
